export default __webpack_public_path__ + "static/media/Theme5.f7b84540.jpg";